import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthHideSpinnerGuard {
  constructor(private authService: AuthService,@Inject(DOCUMENT) private document: Document){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      const spinner = this.document.getElementById("pre-loading-spinner")
      if (spinner) spinner.style.display= "none"
    }
    return true;
  }

}
